exports.onlyAlphaNumeric = (zipCode) => zipCode.replace(/[^\w]/g, '');
exports.onlyNumeric = (zipCode) => zipCode.replace(/[^0-9]/g, '');
exports.onlyNumericPlusDash = (zipCode) => zipCode.replace(/[^0-9/-]/g, '');

exports.zipCodeRegexNumeric = (length) => `^\\d{${length}}$`;
exports.onlyNumericNormalize = (zipCode, length) => {
  if (!zipCode) {
    return zipCode;
  }
  return exports.onlyNumeric(zipCode).slice(0, length);
};

/* If you change the constants - things will blow up in some of our views */
exports.SPACE = 'space';
exports.COMMA = 'comma';
